import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ArrowUpRightBlue,
  facebookIcon,
  googleIcon,
  loginPageCover,
  loginVideo,
  logo,
  logoColor,
  studentSignupCover,
} from "../../../../constant/imagePath";
import { Button } from "../../../../stories/Button/Button";
import { Input } from "../../../../stories/Input/Input";
import classes from "./SignUp.module.css";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import CallMadeIcon from "@mui/icons-material/CallMade";
import {
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { saveLoginUserData } from "../../../../store/Actions/authAction";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import { MobileHeader } from "../../../../stories/MobileHeader/MobileHeader";
import Colors from "../../../../stories/assets/Colors";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import Fonts from "../../../../stories/assets/Fonts";

const SignUp = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  // variables and states
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  // Login With Email and Password
  // const handleSignInAction = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await signInWithEmailAndPassword(auth, email, password);
  //     setLoading(false);

  //     let user = response.user;
  //     const customClaim = await user.getIdTokenResult();
  //     const role = customClaim?.claims?.role;
  //     const emailVerification = customClaim?.claims?.email_verified;
  //     if (role === "student") {
  //       await dispatch(saveLoginUserData(role));
  //       history.push({
  //         pathname: emailVerification ? `/homepage` : `/check-your-email`,
  //         state: email,
  //       });
  //     } else if (role === "coach-pending") {
  //       await dispatch(saveLoginUserData(role));
  //       history.push({
  //         pathname: emailVerification
  //           ? `/coach-setup-profile`
  //           : `/check-your-email`,
  //         state: email,
  //       });
  //     } else {
  //       toast.error(`No user found with this email sign up first.`);
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     const showErrorMessage = await errorMessage(error);
  //     toast.error(showErrorMessage);
  //   }
  // };

  // Social Google Login
  const HandleGoogleLogin = async () => {
    let provider = new GoogleAuthProvider();
    const auth = getAuth();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        let user = result.user;
        const customClaim = await user.getIdTokenResult();
        const role = customClaim?.claims?.role;
        const emailVerification = customClaim?.claims?.email_verified;
        if (role === "student") {
          await dispatch(saveLoginUserData(role));
          history.push({
            pathname: emailVerification ? `/homepage` : `/check-your-email`,
            state: email,
          });
        } else if (role === "coach-pending") {
          await dispatch(saveLoginUserData(role));
          history.push({
            pathname: emailVerification
              ? `/coach-setup-profile`
              : `/check-your-email`,
            state: email,
          });
        } else {
          toast.error(`No user found with this email sign up first.`);
        }
      })
      .catch((error) => {
        toast.error(`Error While Google Login`);
      });
  };

  // Social Facebook Login
  const HandleFacebookLogin = async () => {
    let provider = new FacebookAuthProvider();
    provider.addScope("user_birthday");
    provider.setCustomParameters({
      display: "popup",
    });
    const auth = getAuth();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        let user = result.user;
        const customClaim = await user.getIdTokenResult();
        const role = customClaim?.claims?.role;
        const emailVerification = customClaim?.claims?.email_verified;
        if (role === "student") {
          await dispatch(saveLoginUserData(role));
          history.push({
            state: email,
            pathname: emailVerification ? `/homepage` : `/check-your-email`,
          });
        } else if (role === "coach-pending") {
          await dispatch(saveLoginUserData(role));
          history.push({
            state: email,
            pathname: emailVerification
              ? `/coach-setup-profile`
              : `/check-your-email`,
          });
        } else {
          toast.error(`No user found with this email sign up first.`);
        }
      })
      .catch((error) => {
        toast.error(`Error While Facbook Login`);
      });
  };

  return (
    <>
      <style jsx>{`
        .${classes.mainHeading} {
          font-size: ${Fonts.h3.fontSize};
          line-height: ${Fonts.h3.lineHeight};
          font-family: ${`${Fonts.h3.fontFamily}`};
        }
      `}</style>
      <div className={` ${[classes.loginPage].join(" ")}`}>
        <div className={`container-fluid p-0 ${classes.container}`}>
          {isMobile ? (
            <MobileHeader
              isLogo={true}
              isAvatar={false}
              customStyle={{ padding: "16px 0px" }}
            />
          ) : (
            <BeforeLoginHeader
              onClick={() => {
                history.push({
                  pathname: "login",
                });
              }}
              icon={logo}
              text1={"Already have an account?"}
              text2={"Log In"}
            />
          )}

          <div className="row g-0" style={{ height: "100%" }}>
            <div className="col-md-12">
              <div className="row g-0">
                <div
                  className={`p-0 col-md-6 ${[
                    classes.innerContainer,
                    classes.imageContainer,
                  ].join(" ")}`}
                >
                  <img
                    className="img-fluid d-block w-100 hvh-100"
                    // className="img-fluid d-block w-100 hvh-100"
                    src={studentSignupCover}
                  />

                  {/* <ReactPlayer url={welcomeVideo} loop={true} muted={true} playing={true} className={`${[classes.bannerVideo].join(" ")}`} /> */}
                </div>
                {/* Login Form */}
                <div
                  className={`p-5 col-sm-12 col-md-6  ${[
                    classes.innerContainer,
                    classes?.rightContainer,
                  ].join(" ")}`}
                >
                  <span className={` ${[classes.mainHeading].join(" ")}`}>
                    Tell us about you
                  </span>
                  <div className={classes.width_full_div}>
                    <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>To book your lesson, we need to verify a few things</p>
                  </div>
                  <div className="mb-3 " />
                  <Button
                    primary={false}
                    disabled={loading ? true : false}
                    size={"Large"}
                    label={"Sign in with Facebook"}
                    icon={facebookIcon}
                    onClick={() => {
                      HandleFacebookLogin();
                    }}
                  />
                  <div className="mb-3" />
                  <Button
                    primary={false}
                    disabled={loading ? true : false}
                    size={"Large"}
                    label={"Sign in with Google"}
                    icon={googleIcon}
                    onClick={() => {
                      HandleGoogleLogin();
                    }}
                  />

                  {/* Dont have an account for mobile */}
                  <div className={`col-sm-12 ${classes.footerContainer}`}>
                    <div className={classes.dontHaveAccountForMobile}>
                      <p
                        style={{
                          ...Fonts.p2,
                          color: Colors.neutralShadesOfDimGray,
                        }}
                      >
                        Don’t have an account?
                      </p>
                      <LinkButtonWithIcon
                        className={`${classes.mainColor}`}
                        primary={true}
                        text={"Log in"}
                        rightIcon={ArrowUpRightBlue}
                        iconStyle={{ margin: "0px" }}
                        onClick={() => history.push("/login")}
                      />
                    </div>
                  </div>
                  {/*  */}

                  <div className={`col-md-12`}>
                    <div
                      className={`${[classes.separatorContainer].join(" ")} `}
                    >
                      <div className={`${[classes.Separator].join(" ")}`} />
                      <div className={`${[classes.orSpan].join(" ")}`} style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>or</div>
                      <div className={`${[classes.Separator].join(" ")}`} />
                    </div>
                  </div>

                  <form
                    className="col-md-12"
                    style={{
                      position: "relative",
                    }}
                  >
                    <div className={classes.inputMb32}>
                      <Input
                        type={"email"}
                        label={"Email"}
                        state={email}
                        setter={setEmail}
                        placeholder={""}
                      />
                    </div>
                    <div className={classes.inputMb32}>
                      <Input
                        type={"text"}
                        label={"Full Name"}
                        state={fullName}
                        setter={setFullName}
                        placeholder={""}
                      />
                    </div>
                    <div className={`${classes.inputMb32}`}>
                      <Input
                        type={"text"}
                        label={"PhoneNumber"}
                        state={phoneNumber}
                        setter={setPhoneNumber}
                        placeholder={""}
                      />
                    </div>

                    <div className={`${classes.inputMb32}`}>
                      <Input
                        type={"password"}
                        label={"Password"}
                        state={password}
                        setter={setPassword}
                        placeholder={""}
                      />
                    </div>
                    <div
                      className={`${classes.btnMt32} ${classes.mobileInputMb32}`}
                    >
                      <Button
                        primary={true}
                        size={"Large"}
                        label={loading ? "loading..." : "Continue booking"}
                        disabled={
                          loading
                            ? true
                            : email !== "" &&
                              fullName !== "" &&
                              phoneNumber !== "" &&
                              password !== ""
                              ? false
                              : true
                        }
                        onClick={() => {
                          if (
                            email === "" ||
                            fullName === "" ||
                            password === "" ||
                            phoneNumber === ""
                          ) {
                            return toast.warning("Please fill all the fields");
                          }
                          // handleSignInAction();
                        }}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* Footer */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
